import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import Wordmark from '@/components/generals/wordmark'
import { ATELIER, NAV_LINKS } from '@/constants/site'

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='relative mt-auto bg-bark text-paper'>
            <div className='container-page grid gap-14 py-16 md:grid-cols-12 md:py-20'>
                <div className='md:col-span-5'>
                    <Wordmark tone='paper' />
                    <p className='mt-6 max-w-sm font-heading text-[1.35rem] leading-snug text-paper/90'>
                        Qog&rsquo;oz is the Uzbek word for paper. Ours is still made from mulberry bark, river water and a polishing stone.
                    </p>
                </div>

                <nav aria-label='Footer' className='md:col-span-3 md:col-start-7'>
                    <p className='text-sm font-medium text-paper/70'>
                        Wander
                    </p>
                    <ul className='mt-5 space-y-3'>
                        <li>
                            <Link href='/' className='ink-link pb-0.5 text-paper/90 hover:text-paper'>
                                Home
                            </Link>
                        </li>
                        {NAV_LINKS.map(link => (
                            <li key={link.href}>
                                <Link href={link.href} className='ink-link pb-0.5 text-paper/90 hover:text-paper'>
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                        <li>
                            <Link href='/cart' className='ink-link pb-0.5 text-paper/90 hover:text-paper'>
                                Cart
                            </Link>
                        </li>
                    </ul>
                </nav>

                <div className='md:col-span-3'>
                    <p className='text-sm font-medium text-paper/70'>
                        Visit
                    </p>
                    <address className='mt-5 space-y-2 not-italic text-paper/90'>
                        <p>{ATELIER.place}</p>
                        <p>{ATELIER.region}</p>
                        <p className='pt-2'>{ATELIER.hours}</p>
                        <p className='text-paper/65'>{ATELIER.timezone}</p>
                    </address>
                </div>
            </div>

            <div className='container-page'>
                <div className='stitch text-paper' />
            </div>

            <div className='container-page flex flex-col gap-3 py-7 text-sm text-paper/60 sm:flex-row sm:items-center sm:justify-between'>
                <p>&copy; {ATELIER.year} Qog&rsquo;oz Atelier. Every sheet made by hand near Samarkand.</p>
                <p>Shipping worldwide from Uzbekistan</p>
            </div>
        </footer>
    )
}

export default SiteFooter
